export default class AdsError extends Error {}
